import { EntityType } from 'src/app/core/models/entitlements/entity';
import { InterventionStatus } from 'src/app/core/models/intervention';
import { NeedSource } from 'src/app/core/models/patient-need';

export const PASSWORD_PATTERN_ERROR =
  'Passwords must be at least 8 characters long, must contain 1 number, 1 uppercase letter, 1 lowercase letter, and 1 special character (#?!@$%^&*-). Your password cannot be the same as your last 5 passwords.';

export const DOMAIN_PATTERN_ERROR = 'Email domain should be in the form: @domain.tld';

export const TIME_ZONES = [
  { key: 'IST', value: 'Asia/Kolkata' },
  { key: 'CDT', value: 'America/Chicago' },
  { key: 'MDT', value: 'America/Denver' },
  { key: 'PDT', value: 'America/Los_Angeles' },
  { key: 'EDT', value: 'America/New_York' },
  { key: 'WAT', value: 'Africa/Douala' },
  { key: 'CAT', value: 'Africa/Gaborone' },
  { key: 'EAT', value: 'Africa/Dar_es_Salaam' },
  { key: 'SAST', value: 'Africa/Johannesburg' }
];

export const CHALLENGE_QUESTIONS = [
  'What was the name of your first stuffed animal?',
  'In what town was your first job?',
  'What was the name of your elementary/Primary School?',
  'What is your maternal grandmothers maiden name?',
  'In what city or town did your mother and father meet?',
  'What is your mothers maiden name?',
  'What is the middle name of your youngest child?',
  'What is the name of your favorite childhood friend?',
  'In what city did you meet your spouse/significant other?',
  'What was your childhood nickname?'
];

export const GENDERS = [
  { key: 'UNK', value: 'Unknown' },
  { key: 'M', value: 'Male' },
  { key: 'F', value: 'Female' },
  { key: 'O', value: 'Other' }
];

export const COUNTRIES = [
  { key: 'USA', value: 'USA' },
  { key: 'INDIA', value: 'INDIA' },
  { key: 'ZA', value: 'SOUTH AFRICA' }
];

export const RACES = [
  'American Indian/Alaska Native',
  'Asian',
  'Black/African American',
  'Native Hawaiian',
  'Other Pacific Islander',
  'White',
  'Other',
  'I choose not to answer this question'
];

export const PRONOUNS = [
  { key: 'She/Her', value: 'She/Her' },
  { key: 'He/Him', value: 'He/Him' },
  { key: 'They/Them', value: 'They/Them' },
  { key: 'Other', value: 'Other' },
  { key: 'NR', value: 'I prefer not to say' }
];

export const ETHNICITIES = ['Hispanic', 'Non-Hispanic', 'I choose not to answer this question', 'No Answer Provided'];

export const OWNER_TYPES = [
  { key: EntityType.CARECOORDINATOR, value: 'Care Coordinator' },
  { key: EntityType.CARECOORDINATOR, value: 'Care Manager' },
  { key: EntityType.CAREGIVER, value: 'Care Giver' }
];

export const PATIENT_SEARCH_OWNER_TYPES = [{ key: EntityType.CARECOORDINATOR, value: 'Care Manager/Care Coordinator' }];

export const NEEDS_SOURCE = [
  { key: NeedSource.ASSESSMENT, value: 'ASSESSMENT' },
  { key: NeedSource.DIAGNOSIS, value: 'DIAGNOSIS' },
  { key: NeedSource.VISIT, value: 'VISIT' },
  { key: NeedSource.OTHER, value: 'OTHER' }
];

export const NEEDS_IDENTIFIED_BY = [
  { key: EntityType.CARECOORDINATOR, value: 'CARE COORDINATOR' },
  { key: EntityType.CARECOORDINATOR, value: 'CARE MANAGER' },
  { key: EntityType.PATIENT, value: 'PATIENT' },
  { key: EntityType.OTHER, value: 'OTHER' }
];

export const INTERVENTION_STATUSES_WITHOUT_ALL = [
  {
    key: InterventionStatus.INPROGRESS,
    value: 'In Progress'
  },
  {
    key: InterventionStatus.INCOMPLETE_NO_LONGER_APPLICABLE,
    value: 'Incomplete - No Longer Applicable'
  },
  {
    key: InterventionStatus.INCOMPLETE_PATIENT_REFUSAL,
    value: 'Incomplete - Patient Refusal'
  },
  {
    key: InterventionStatus.COMPLETE,
    value: 'Complete'
  }
];

export const INTERVENTION_STATUSES_WITH_ALL = [
  ...INTERVENTION_STATUSES_WITHOUT_ALL,
  {
    key: [
      InterventionStatus.INPROGRESS,
      InterventionStatus.INCOMPLETE_NO_LONGER_APPLICABLE,
      InterventionStatus.INCOMPLETE_PATIENT_REFUSAL,
      InterventionStatus.COMPLETE
    ].join(';'),
    value: 'All'
  }
];

export const MANUAL_PATIENT_ENTRY_PLANIDS = ['UNINSURED', 'MEDICAID'];

export const RECORDS_PER_PAGE: number[] = [10, 25, 50, 100];

export const BUNDLE_ENTITY_TASK_NOTES_MAX_LENGTH = 5000;

export class RegistrationFormFieldConfig {
  nickName = true;
  password = true;
  passphrase = true;
  securityQuestion = true;
  securityQuestionAnswer = true;
  gender = true;
  country = true;
  timeZone = true;
  telePin = true;
}

export const CASE_REVIEW_NOTES_MAX_LENGTH = 2000;
